export enum Hydrologie {
    Inconnue = 0,
    PasDeau = 1,
    TrousDeauFlaques = 2,
    BassesEaux = 3,
    MoyennesEaux = 4,
    LitPlein = 5,
    CrueDebordante = 6,
}
